import React from 'react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'

import ControlLabel from 'react-bootstrap/lib/ControlLabel'
import Form from 'react-bootstrap/lib/Form'
import FormGroup from 'react-bootstrap/lib/FormGroup'
import FormControl from 'react-bootstrap/lib/FormControl'

function PerPage({ currentNumItemsPerPage, onChange, options, total }) {
  function handleOnChange(evt) {
    onChange(parseInt(evt.target.value, 10))
  }

  return (
    <Form inline={true}>
      <FormGroup controlId="perPage">
        <ControlLabel>Per page:</ControlLabel>
        <FormControl
          componentClass="select"
          placeholder="select"
          onChange={handleOnChange}>
          {options.map((option, i) => {
            // Hide options that exceed the total number of hits.
            const prevIdx = i - 1 < 0 ? 0 : i - 1
            const prevOpt = options[prevIdx]
            if (total < prevOpt) return null
            return (
              <option
                selected={option === currentNumItemsPerPage}
                key={option}
                value={option}>
                {option}
              </option>
            )
          })}
        </FormControl>
      </FormGroup>
    </Form>
  )
}

PerPage.propTypes = {
  currentNumItemsPerPage: PropTypes.number,
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.number),
  total: PropTypes.number,
}

PerPage.defaultProps = {
  currentNumItemsPerPage: 50,
  onChange: () => {},
  options: [50, 100, 500, 1000, 10000],
  total: 10000,
}

export default observer(PerPage)
